import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BcEmployeeAuthGuard } from '@bayclubs/employee-auth';
import { AuthService } from '@bayclubs/horizon';
import { environment } from '../../../environments/environment';

const HORIZON_RETURN_URL_KEY = 'horizon.auth.returnUrl';

export const dualAuthGuard: CanActivateFn = (route, state) => {
    if (environment.isMsalAuthenticationEnabled) {
        const authService = inject(AuthService);
        if (!authService.isAuthenticated()) {
            // AuthService.navigateAfterLogin() reads from sessionStorage[HORIZON_RETURN_URL_KEY].
            // MsalGuard does NOT write to this key, so after Azure AD login the user would land
            // at '/' instead of the intended route. We save it here first.
            sessionStorage.setItem(HORIZON_RETURN_URL_KEY, state.url);
        }
        return inject(MsalGuard).canActivate(route, state);
    }
    return inject(BcEmployeeAuthGuard).canActivate(route, state);
};
